module.exports = __webpack_public_path__ + "media/effects-9.239e07f9.webm";